import React from 'react'
import classnames from 'classnames'
import BaseButton from 'src/Components/shared/Button/BaseButton'

import styles from './GemContainer.module.scss'

const GemContainer = React.forwardRef(({ className, ...restProps }, ref) => (
  <BaseButton
    className={classnames(styles.root, className)}
    ref={ref}
    {...restProps}
  />
))

export default GemContainer
